import CookieUsed from "@quarkly/community-kit/CookieUsed";
export default CookieUsed;